import {useEffect, useState} from "react";
import {findMollieSettlementTransactionsWithPagination} from "../api/eventGroupApiClient";

export const useMollieSettlementTransactions = (settlementId, page, pageSize, reloadTrigger) => {
    const [transactions, setTransactions] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const transactionsWithPagination = findMollieSettlementTransactionsWithPagination(settlementId, page, pageSize, abortController.signal);

        transactionsWithPagination
            .then(
                (data) => {
                    const transactions = data.transactions;
                    const pagination = data.pagination;

                    setTransactions(transactions)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [settlementId, page, pageSize, reloadTrigger]);

    return {transactions : transactions, pagination};
};
